import * as React from 'react';
import get from 'lodash/get';
import { EMPTY_TEXT, NUMBER_ZERO } from '@mitchell/react.component.ux';
import { EnterpriseDocStoreService, TranslationService } from "../../../common";
import { VehicleInfoState, VehicleSelectionContainer, VehicleSelectionMethod, VehicleSelectionHierarchyLabel } from "../../../vehicleInfo";
import { IntelligentPhotoCaptureViewType, PhotoCaptureAttributeType } from '../../enums';
import { IntelligentPhotoCaptureAddViewConstants, OCR_previewScreen_RegEx_validator, PhotoCaptureConstants, VIN_INVALID_MESSAGE } from '../../constants';
import { StyledImageDiv, StyledVinDecodeSection, StyledVinDivContainer } from '../VinDecodeComponent.style';
import { IntelligentPBEContainerComponent } from './IntelligentPBEContainerComponent';
import { IntelligentPhotoCaptureImageSection } from './IntelligentPhotoCaptureImageSection';
import { StyledRefreshIconSpan } from './IntelligentPageGuidanceInfo.style';
export const IntelligentVinDecodeComponent = ({ appTheme, vehicleInfoData = new VehicleInfoState().vehicleInfoData, answerList, questionSubType, files, ocrInfo, warningMessage, vinErrorState, onResetVehicleInfo, onFlyoutClicked, onViewChange, onVinUpdated, onVehicleInfoUpdated, onOcrVinUpdate, updatePageAttachmentHistory, isEnabled, loadVehicleConfigurationAttributes }) => {
    const ocrText = (ocrInfo && ocrInfo.ocrText) || EMPTY_TEXT;
    const translateFn = TranslationService.translate;
    const [vin, setVin] = React.useState(ocrText);
    const [errorMessage, setErrorMessage] = React.useState(warningMessage);
    const [vehicleVinInfoData, setVehicleVinInfoData] = React.useState(new VehicleInfoState().vehicleInfoData);
    React.useLayoutEffect(() => {
        if (vehicleVinInfoData && vehicleVinInfoData.Vin) {
            setVin(vehicleVinInfoData.Vin);
            if (vehicleVinInfoData.Vehicle && vehicleVinInfoData.Vehicle.Value) {
                for (let item in VehicleSelectionHierarchyLabel) {
                    if (vehicleVinInfoData[item.toString()].length > 1) {
                        const selectedItem = vehicleVinInfoData[item.toString()].find(data => vehicleVinInfoData.Vehicle &&
                            vehicleVinInfoData.Vehicle.Value[item.toString().slice(0, -1)].Id === data.Id);
                        selectedItem &&
                            onFlyoutClicked(vehicleVinInfoData, selectedItem, VehicleSelectionHierarchyLabel[item.toString()], VehicleSelectionMethod.VinDecode);
                    }
                }
            }
        }
    }, [vehicleVinInfoData.Vin]);
    React.useLayoutEffect(() => {
        const vehicleVinDataLocal = answerList && answerList[0].answerDisplayText && JSON.parse(answerList[0].answerDisplayText)[0].vehicleVinData;
        if (questionSubType === PhotoCaptureAttributeType.VIN_CAPTURE && vehicleVinDataLocal) {
            setVehicleVinInfoData(vehicleVinDataLocal);
            onVehicleInfoUpdated(vehicleVinDataLocal);
        }
    }, [answerList]);
    React.useLayoutEffect(() => {
        if (vehicleInfoData && vehicleInfoData.Vin) {
            setVehicleVinInfoData(vehicleInfoData);
            setErrorMessage(EMPTY_TEXT);
        }
        else if (vinErrorState && !vehicleInfoData.Vin) {
            onResetVehicleInfo(VehicleSelectionMethod.VinDecode, vehicleInfoData.Vin);
        }
        else {
            onResetVehicleInfo(VehicleSelectionMethod.VinDecode, vehicleInfoData.Vin);
        }
        setVin(vehicleInfoData.Vin || EMPTY_TEXT);
    }, [vehicleInfoData.Vin]);
    React.useLayoutEffect(() => {
        if (!ocrText) {
            if (ocrInfo.errorMessage) {
                onResetVehicleInfo(VehicleSelectionMethod.VinDecode, vehicleInfoData.Vin);
                setErrorMessage(ocrInfo.errorMessage);
            }
            return;
        }
        const isValidVin = OCR_previewScreen_RegEx_validator.VIN_DECODE_REGEX.test(ocrText);
        onResetVehicleInfo(VehicleSelectionMethod.VinDecode, vehicleInfoData.Vin);
        onVinUpdated(ocrText, VehicleSelectionMethod.VinDecode);
        setErrorMessage(isValidVin ? EMPTY_TEXT : VIN_INVALID_MESSAGE);
    }, [ocrText, ocrInfo.errorMessage]);
    React.useEffect(() => {
        handleHistoryInfo();
    }, [ocrInfo.isOCRServiceCallCompleted]);
    React.useEffect(() => {
        setErrorMessage(warningMessage);
    }, [warningMessage]);
    const handleNext = () => {
        if (vin && vin.length !== PhotoCaptureConstants.VIN_LENGTH) {
            setErrorMessage(VIN_INVALID_MESSAGE);
        }
        else {
            if (isEnabled('shouldEnableOCRImageTextDecode') && files && files[0] && files[0].docUID) {
                updatePageAttachmentHistory(files[0].docUID, { ocrTextFinal: vin });
            }
            onOcrVinUpdate &&
                onOcrVinUpdate({
                    ocrText: vin,
                    errorMessage: EMPTY_TEXT
                });
            get(vehicleInfoData, 'Vehicle') &&
                loadVehicleConfigurationAttributes &&
                loadVehicleConfigurationAttributes({ vehicleId: get(vehicleInfoData, 'Vehicle.Id', NUMBER_ZERO) });
            onViewChange(IntelligentPhotoCaptureViewType.COMMENT);
        }
    };
    const handleMove = () => {
        const vehicleVinDataLocal = answerList && answerList[0].answerDisplayText && JSON.parse(answerList[0].answerDisplayText)[0].vehicleVinData;
        onResetVehicleInfo(VehicleSelectionMethod.VinDecode, EMPTY_TEXT);
        onViewChange(vehicleVinDataLocal ? IntelligentPhotoCaptureViewType.NONE : IntelligentPhotoCaptureViewType.CAMERA);
    };
    const handleHistoryInfo = () => {
        if (isEnabled('shouldEnableOCRImageTextDecode') &&
            ocrInfo.isOCRServiceCallCompleted &&
            files &&
            files[0] &&
            files[0].docUID) {
            updatePageAttachmentHistory(files[0].docUID, { ocrText: ocrInfo.ocrText });
        }
    };
    return (React.createElement(IntelligentPBEContainerComponent, { warningMessage: translateFn(errorMessage), islanguageHide: true, appTheme: appTheme, isFooter: true, hasMultipleButton: false, movePrevious: handleMove, moveNext: handleNext, shouldShowAvatar: false, btnLabel: translateFn(PhotoCaptureConstants.NEXT), isBtnDisabled: !vin },
        React.createElement(StyledImageDiv, { container: true, id: `${IntelligentPhotoCaptureAddViewConstants.IMAGE_CONTAINER_BOX}` },
            React.createElement(IntelligentPhotoCaptureImageSection, { imageSrc: EnterpriseDocStoreService.createFileUrl((files && files.length && files[0].thumbnail && files[0].thumbnail.docUID) || EMPTY_TEXT) },
                React.createElement(StyledRefreshIconSpan, { id: `${IntelligentPhotoCaptureAddViewConstants.IMAGE_RETAKE_ICON}`, className: "mi-icon-refresh", isParentImage: true, onClick: handleMove }))),
        React.createElement(StyledVinDecodeSection, null,
            React.createElement(StyledVinDivContainer, null,
                React.createElement(VehicleSelectionContainer, { isDisabled: false, shouldShowManualOption: false, t: translateFn })))));
};
//# sourceMappingURL=IntelligentVinDecodeComponent.js.map